<template>
  <div
    :class="{
      transparent,
      mobileMenu,
      noHeader,
      mobileHeader,
    }"
    class="HrHeader"
  >
    <div class="HrHeader__menu-container visible-xs">
      <co-icon
        v-if="!menuState"
        class="HrHeader__menu co-icon--arrow-left"
        name="arrow-left"
        data-test-id="hr-header-mobile-back"
        @click="menuClicked"
      />
      <img
        class="HrHeader__logo2"
        src="../../static/images/logo-letters-color.svg"
      />
    </div>
    <img
      class="HrHeader__logo hidden-xs"
      src="../../static/images/logo-icon-color.svg"
    />
  </div>
</template>

<script>
import { computed } from 'vue';
import store from '@/store';
import { CoIcon } from '@deputy/copilot2';
export default {
  name: 'hr-header',
  components: { CoIcon },
  props: {
    transparent: {
      type: Boolean,
      default: false,
    },
    noHeader: {
      type: Boolean,
      default: false,
    },
    mobileMenu: {
      type: Boolean,
      default: false,
    },
    mobileHeader: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const menuState = computed(() => store.state.menuState);

    function menuClicked() {
      if (props.mobileMenu) {
        emit('menuClicked');
      }
    }

    return {
      menuState,
      menuClicked,
    };
  },
};
</script>

<style scoped lang="scss">
@import '~@/core/style-vars.scss';

.HrHeader {
  height: 50px;
  width: 100%;
  background-color: $co-background-secondary;
  border-bottom: 1px solid $co-border-transparent;
  z-index: 10;
}

.HrHeader__logo {
  height: 28px;
  margin-top: 10px;
  margin-left: 15px;
}

.HrHeader__menu-container__logo {
  flex: 1;
  text-align: center;
}

.HrHeader__menu {
  cursor: pointer;
  color: $co-text-link;
  width: 20px !important;
  height: 20px !important;
  position: absolute;
  top: 15px;
  left: 15px;
  display: none;
}

.HrHeader__logo2 {
  height: 20px;
  margin-top: 17px;
  margin-left: 15px;
}

.HrHeader__menu-container {
  text-align: center;
}

.HrHeader.transparent {
  background-color: transparent;
}

.HrHeader.noHeader {
  display: none;
}

@media (max-width: 767px) {
  .HrHeader.mobileMenu,
  .HrHeader.mobileMenu .HrHeader__menu,
  .HrHeader.mobileHeader {
    display: inline;
  }
}

@media print {
  .HrHeader {
    display: none !important;
  }
}
</style>
